import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PortfolioSection, TestimonialsSection, FinalCta } from "../../components/sections";
import { Reveal } from "../../components/Reveal";

export default function Work() {
  const [portfolio, setPortfolio] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [filter, setFilter] = useState("All");
  useEffect(() => {
    api.get("/content/portfolio").then(({ data }) => setPortfolio(data));
    api.get("/content/testimonials").then(({ data }) => setTestimonials(data));
  }, []);
  const cats = ["All", ...Array.from(new Set(portfolio.map((p) => p.category).filter(Boolean)))];
  const filtered = filter === "All" ? portfolio : portfolio.filter((p) => p.category === filter);
  return (
    <>
      <section className="pt-36 pb-4 px-5 sm:px-8" data-testid="work-page">
        <div className="max-w-7xl mx-auto text-center">
          <Reveal>
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-brand-orange">Our Work</span>
            <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-6xl text-brand-purpleDeep leading-tight">
              Good videos speak for themselves.
            </h1>
          </Reveal>
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  filter === c ? "bg-brand-purple text-white" : "bg-white border border-border text-brand-purpleDeep/70 hover:border-brand-purple"
                }`}
                data-testid={`work-filter-${c}`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>
      <PortfolioSection projects={filtered} />
      <TestimonialsSection testimonials={testimonials} />
      <FinalCta />
    </>
  );
}
